import { render, staticRenderFns } from "./Atividade.vue?vue&type=template&id=d810b310&"
import script from "./Atividade.vue?vue&type=script&lang=js&"
export * from "./Atividade.vue?vue&type=script&lang=js&"
import style0 from "./Atividade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports